// prettier-ignore
import { TextField } from '@mui/material';
import styled from 'styled-components';

export const StyledTextField = styled(TextField)`
  input {
    --tw-ring-shadow: 0 0 #000 !important;
  }
`;
